if (!customElements.get('card-product-gallery')) {
  customElements.define(
    'card-product-gallery',
    class CardProductGallery extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (this._galleryBound) return;

        const track = this.querySelector('.card-product-gallery__track');
        if (!track) return;

        this._galleryBound = true;
        this._track = track;

        this._onScrollBound = this.handleScroll.bind(this);
        track.addEventListener('scroll', this._onScrollBound, { passive: true });

        this._resizeObserver = new ResizeObserver(() => this.syncProgressBar());
        this._resizeObserver.observe(track);

        this.syncProgressBar();
      }

      disconnectedCallback() {
        if (!this._galleryBound) return;
        this._galleryBound = false;

        const track = this._track;
        if (track) {
          if (this._onScrollBound) {
            track.removeEventListener('scroll', this._onScrollBound, { passive: true });
          }
        }

        if (this._resizeObserver) {
          this._resizeObserver.disconnect();
          this._resizeObserver = null;
        }

        this._track = null;
        this._onScrollBound = null;
      }

      getProgressRoot() {
        const parent = this.parentElement;
        if (parent && parent.classList.contains('card-gallery__hover')) {
          return parent;
        }
        return this;
      }

      getSlideStep(track, slides) {
        if (slides.length > 1) return slides[1].offsetLeft - slides[0].offsetLeft;
        return track.clientWidth;
      }

      syncProgressBar() {
        const track = this.querySelector('.card-product-gallery__track');
        if (!track) return;

        const slides = track.querySelectorAll(':scope > .card-product-gallery__slide');
        const n = parseInt(this.dataset.slidesCount, 10) || slides.length;
        if (!slides.length || n < 1) return;

        const step = this.getSlideStep(track, slides);
        if (!step) return;

        let idx = Math.round(track.scrollLeft / step);
        idx = Math.max(0, Math.min(n - 1, idx));
        this.getProgressRoot().style.setProperty('--slider-index', String(idx));
      }

      handleScroll() {
        this.syncProgressBar();
      }
    }
  );
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target && typeof customElements.upgrade === 'function') {
    customElements.upgrade(event.target);
  }
});
